var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasAnyAuthority("ROLE_ADMIN")
    ? _c(
        "div",
        { staticClass: "sidebar" },
        [
          _c(
            "b-sidebar",
            {
              attrs: {
                "bg-variant": "dark",
                "text-variant": "light",
                id: "sidebar-footer",
                "data-cy": "sidebar",
                "no-close-on-route-change": "",
                "no-close-on-esc": "",
                visible: ""
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "footer",
                    fn: function(ref) {
                      var hide = ref.hide
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "d-flex text-light align-items-center"
                          },
                          [
                            _c(
                              "b-button",
                              {
                                attrs: { block: "", variant: "primary" },
                                on: { click: hide }
                              },
                              [
                                _c("font-awesome-icon", {
                                  attrs: { icon: "angle-double-left" }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    }
                  }
                ],
                null,
                false,
                3598281897
              )
            },
            [
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "px-3" },
                [
                  _c(
                    "b-nav",
                    {
                      attrs: {
                        vertical: "",
                        "text-variant": "light",
                        "aria-label": "Sidebar",
                        "no-header": ""
                      }
                    },
                    [
                      _c(
                        "b-nav-item",
                        { attrs: { to: "/applications/instances" } },
                        [
                          _c("font-awesome-icon", { attrs: { icon: "cube" } }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Instances")])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-nav-item",
                        {
                          attrs: {
                            to: "/applications/metric",
                            "data-cy": "metricsMenu"
                          }
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "tachometer-alt" }
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Metrics")])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-nav-item",
                        {
                          attrs: {
                            to: "/applications/caches",
                            "data-cy": "cachesMenu"
                          }
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "layer-group" }
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Caches")])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-nav-item",
                        {
                          attrs: {
                            to: "/applications/health",
                            "data-cy": "healthMenu"
                          }
                        },
                        [
                          _c("font-awesome-icon", { attrs: { icon: "heart" } }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Health")])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-nav-item",
                        {
                          attrs: {
                            to: "/applications/liquibase",
                            "data-cy": "liquibaseMenu"
                          }
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "database" }
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Liquibase")])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-nav-item",
                        {
                          attrs: {
                            to: "/applications/configuration",
                            "data-cy": "configurationMenu"
                          }
                        },
                        [
                          _c("font-awesome-icon", { attrs: { icon: "list" } }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Configuration")])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-nav-item",
                        {
                          attrs: {
                            to: "/applications/loggers",
                            "data-cy": "logsMenu"
                          }
                        },
                        [
                          _c("font-awesome-icon", { attrs: { icon: "tasks" } }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Logs")])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-nav-item",
                        {
                          attrs: {
                            to: "/applications/logfile",
                            "data-cy": "logsfileMenu"
                          }
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "indent" }
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Logfile")])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.openAPIEnabled
                        ? _c(
                            "b-nav-item",
                            {
                              attrs: {
                                to: "/applications/docs",
                                "data-cy": "openAPIMenu"
                              }
                            },
                            [
                              _c("font-awesome-icon", {
                                attrs: { icon: "book" }
                              }),
                              _vm._v(" "),
                              _c("span", [_vm._v("API")])
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "fixed-bottom hipster img-fluid" })
                ],
                1
              )
            ]
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }